import { Component } from "react";
import { LabelContainer } from "../assets/style";

export default function FormInput(props: { title: any, value: any, setMethod: (value: string) => void, style?: any }) {
    const { title, value, setMethod, style } = props
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        // maxWidth: "250px",
        width: "50%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "600px",
    };
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setMethod(event.target.value);
    // };

    return (
        <div style={containerStyle}>
            <LabelContainer style={{ marginLeft: "28px" }}>
                {title + ": "}
            </LabelContainer>
            <input
                style={inputStyle}
                value={value}
                // onChange={handleChange}
                onChange={(event) => {
                    setMethod(event.target.value)
                }}
            />

        </div>
    );
}
